import { render, staticRenderFns } from "./alimentarea-publica.vue?vue&type=template&id=63f89bf0&scoped=true"
import script from "./alimentarea-publica.vue?vue&type=script&lang=js"
export * from "./alimentarea-publica.vue?vue&type=script&lang=js"
import style0 from "./alimentarea-publica.vue?vue&type=style&index=0&id=63f89bf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f89bf0",
  null
  
)

export default component.exports